import React, { useContext } from "react";
import { AgGridReact } from "ag-grid-react";
import { IWorkorder } from "../../../../app/models/workorder";
import WorkOrderStore from "../../../../app/stores/workorderStore";
import { observer } from "mobx-react-lite";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { throws } from "assert";
import { GridOptions, GridOptionsWrapper, IGetRowsParams, RowPositionUtils } from "ag-grid-community";
import { table } from "console";
import oneOrderStore from "../../../../app/stores/oneOrderStore";
import WorkorderStore from "../../../../app/stores/workorderStore";



interface IProps {
  workorders: IWorkorder[];
}

  //ADD 230811 for checking user
  let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!) 

const AgedDebtGrid: React.FC<IProps> = props => {
  const workorderStore = useContext(WorkorderStore);
  const { selectWorkOrder } = workorderStore;

  const GetSelectedRow = (params: any) => {
    if (params.node.selected === true) {
      console.log("lol");
      var JobId: string = params.node.data.JobId;
      console.log(JobId)
      console.log("lol2");

      selectWorkOrder(JobId,sessionObj.User.Username);
      console.log("lol3");

    }
    
  };
  const onGridReady = (params: any) => {
    
    params.api.sizeColumnsToFit();

  };

  return (
    <div className="table-responsive">
      <div
        className="ag-theme-material"
        style={{ height: "400px", width: "auto" }}
        
      >
        <AgGridReact
           enableSorting={true}
           enableColResize={true}
           rowSelection={"single"}
           onGridReady={onGridReady}
           pagination={true}
           floatingFilter={true}
           onRowSelected={GetSelectedRow}
           suppressPaginationPanel={true}
           //rowModelType={"infinite"}
           columnDefs={[
            {
              headerName: "Client Ref",
              field: "ClientRef",
              width: 150,
              filter:true,
              suppressMenu:true
            },

            { headerName: "Job No", field: "JobNo", width: 150,filter:true,suppressMenu:true},
            { headerName: "Job Substatus", field: "JobSubStatus",filter:true,suppressMenu:true},
        
            {
              headerName: "Raised Date",
              field: "DateRaised",
              type: "dateColumn",
              sort: "desc",
              valueFormatter: dateFormatter,filter:true,suppressMenu:true
            },
            {
                headerName: "Invoice Number",
                field: "InvoiceNumber",
                sort: "desc",
                filter:true,suppressMenu:true
              },
            {
              headerName: "Target Date",
              field: "TargetDate",
              type: "dateColumn",
              valueFormatter: dateFormatter,filter:true,suppressMenu:true
              
            },
            { headerName: "Job Value", field: "JobValue", valueFormatter: currencyFormatter,filter:true,suppressMenu:true }
          ]}
          rowData={props.workorders}
        ></AgGridReact>
      </div>
    </div>
  );
};


function dateFormatter(params:any) {
  var date = new Date(params.value);
  return date.toLocaleString();
}

function currencyFormatter(params:any) {
  return "\xA3" + params.value.toFixed(2);
}


export default observer(AgedDebtGrid);
